// extracted by mini-css-extract-plugin
export default {"root":"text-area_root__42Ni3","inputError":"text-area_inputError__3hNIK"};